'use client'

import AuthPageContents from '@/app/components/auth'
import { modalBoxClassName, modalClassName } from '@/app/components/modal'
import { useAuthModal } from '@/context/auth-modal-context'
import { cn } from '@/util/cn'
import useClientRender from '@/util/use-client-render'
import { createPortal } from 'react-dom'
import { useEffect } from 'react'
import { useKeyPress } from 'react-use'

const AuthModal = () => {
    const isClient = useClientRender()
    const [isEsc] = useKeyPress('Escape')
    const { closeAuthModal, completeAuth, isOpen, next, setView, view } = useAuthModal()

    useEffect(() => {
        if (isEsc && isOpen) {
            closeAuthModal()
        }
    }, [closeAuthModal, isEsc, isOpen])

    if (!isClient || !isOpen) {
        return null
    }

    return createPortal(
        <div className={cn(modalClassName, 'bg-giphyBlack/95')} onClick={closeAuthModal}>
            <div
                className={cn(modalBoxClassName, 'min-h-0 w-auto max-w-none overflow-visible bg-transparent p-0')}
                onClick={(event) => {
                    event.stopPropagation()
                }}
            >
                <AuthPageContents
                    initialView={view}
                    mode="modal"
                    next={next}
                    onAuthSuccess={completeAuth}
                    onClose={closeAuthModal}
                    onViewChange={setView}
                />
            </div>
        </div>,
        document.body
    )
}

export default AuthModal
